module.exports = __webpack_public_path__ + "img/play_btn.1ca8b773.png";